import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { LOWERCASE_MARKED, MARKED_COMPLETE } from 'src/services/constants/activites';
import ReadIcon from 'src/assets/icons/read-message.svg';
import { useGroupsStyles } from 'src/components/CheckLists/Groups/Groups.styles';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

interface Props {
  handleMarkAsComplete: any;
  labelText?: string;
  toolTipText?: string;
}

const MarkAsComplete: React.FC<Props> = (props: any) => {
  const { handleMarkAsComplete, toolTipText, labelText } = props;
  const useGroupClasses = useGroupsStyles();

  const doMarkAsComplete = () => {
    handleMarkAsComplete(MARKED_COMPLETE, LOWERCASE_MARKED);
  };

  return (
    <Tooltip data-test-id={'t--mark_as_complete'} title={toolTipText || "Mark as Complete"} placement="top" arrow>
      <IconButton
        onClick={doMarkAsComplete}
        className={useGroupClasses.actionIcon}
      >
        {labelText && <Typography fontSize={'14px'} mr={1}>{labelText}</Typography>}
        <ReadIcon width={18} height={20} />
      </IconButton>
    </Tooltip>
  );
};

export default MarkAsComplete;
